module.exports = __webpack_public_path__ + "static/media/config.504f20eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/import-status-icons/config.svg
// module id = 7680
// module chunks = 0